// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { outwardSquaresThree16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-outward-squares-three': IconOutwardSquaresThree;
    }
}

/**
 * The icon component for the 'outwardSquaresThree' icon
 */
export class IconOutwardSquaresThree extends Icon {
    public constructor() {
        super(outwardSquaresThree16X16);
    }
}

registerIcon('icon-outward-squares-three', IconOutwardSquaresThree);
export const iconOutwardSquaresThreeTag = 'nimble-icon-outward-squares-three';
